import * as React from "react"
import { AlertTriangle } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { useBookingT } from "@/hooks/use-translations"

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  integrationName: string
  onConfirm: () => void
}

export function DisconnectModal({ open, onOpenChange, integrationName, onConfirm }: Props) {
  const t = useBookingT()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="size-5 text-warning-500" />
            {t("integrations_disconnect_title", "Disconnect integration?")}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-neutral-700">
          {t(
            "integrations_disconnect_desc",
            "This integration will stop working and any related processes will be paused.",
          )}{" "}
          <span className="font-medium text-neutral-900">{integrationName}</span>
        </p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t("integrations_disconnect_cancel", "Cancel")}
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              onConfirm()
              onOpenChange(false)
            }}
          >
            {t("integrations_disconnect_confirm", "Disconnect")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
